import Component from '../core/Component'
import { queries, CMS } from '../core/config'
import enquire from 'enquire.js'
import Scroll from '../services/Scroll'
import InputResolver from '../meta/TouchMouseInputResolver'

export const defaults = {
    media: 'all'
}

export default class SideScroller extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            content: null,
            slider: null
        }

        this.limit = {
            min: 0,
            max: 0
        }

        this.isActive = false
        this.canAttach = false

        this.enquireQuery = this.options.media in queries ? queries[this.options.media] : this.options.media
        this.enquireHandler = {
            match: this.match,
            unmatch: this.unmatch,
            destroy: this.unmatch
        }
    }

    prepare() {
        if (CMS) {
            return
        }

        enquire.register(this.enquireQuery, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(this.enquireQuery, this.enquireHandler)
    }

    match = () => {
        InputResolver.on('change', this.handleInputChange)
        if (InputResolver.current === InputResolver.MOUSE) {
            this.attach()
        }
    }

    unmatch = () => {
        InputResolver.off('change', this.handleInputChange)
        this.detach()
    }

    attach = () => {
        Scroll.on('resize', this.handleResize)
        Scroll.on('scroll', this.handleScroll)

        this.ref.spacer = document.createElement('div')
        this.ref.spacer.classList.add('SectionSpacer-spacer')
        this.element.appendChild(this.ref.spacer)

        this.resize()
    }

    detach = () => {
        Scroll.off('resize', this.handleResize)
        Scroll.off('scroll', this.handleScroll)

        if (this.ref.spacer) {
            this.ref.spacer.parentNode.removeChild(this.ref.spacer)
            this.ref.spacer = null
        }

        this.ref.content.removeAttribute('style')
        this.ref.slider.removeAttribute('style')
    }

    handleResize = event => {
        this.resize()
    }

    handleScroll = ({ offset }) => {
        this.render(offset.y)
    }

    handleInputChange = ({ type }) => {
        if (type === InputResolver.MOUSE) {
            this.attach()
        } else if (type === InputResolver.TOUCH) {
            this.detach()
        }
    }

    render(scrollTop) {
        if (scrollTop < this.limit.min || scrollTop > this.limit.max) {
            if (this.isActive) {
                this.isActive = false

                if (scrollTop < this.limit.min) {
                    this.ref.content.style.transform = `translateY(0px)`
                    this.ref.slider.style.transform = `translateX(0px)`
                }

                if (scrollTop > this.limit.max) {
                    this.ref.content.style.transform = `translateY(${this.limit.max - this.limit.min}px)`
                    this.ref.slider.style.transform = `translateX(${this.limit.min - this.limit.max}px)`
                }
            }
            return
        }

        this.isActive = true

        const offset = scrollTop - this.limit.min

        this.ref.content.style.transform = `translateY(${offset}px)`
        this.ref.slider.style.transform = `translateX(${-offset}px)`
    }

    resize() {
        const sliderBox = this.ref.slider.getBoundingClientRect()
        const contentBox = this.ref.content.getBoundingClientRect()

        const offsetHeight = this.ref.slider.scrollWidth - sliderBox.width

        const windowHeight = window.innerHeight

        const scrollOffset = Scroll.getScroll()

        this.limit.min = scrollOffset.y + sliderBox.top + sliderBox.height/2 - windowHeight/2
        this.limit.max = this.limit.min + offsetHeight

        this.ref.spacer.style.height = `${offsetHeight + contentBox.height}px`

        this.render(scrollOffset.y)
    }

}
